module.exports = __webpack_public_path__ + "img/dk_lct.8225a684.png";